module.exports = __webpack_public_path__ + "img/img1.64a5b64e.svg";